// extracted by mini-css-extract-plugin
export default {"skeletonCard":"CardSkeleton_skeletonCard__osp3K","fade-in":"CardSkeleton_fade-in__uI3B9"};